import { Component, OnInit } from '@angular/core';
import {LOG_LEVEL, LoggerService} from '@util/logger.service';
import {AppDataService} from '@api/app-data.service';

interface iOsAppMetaData {
  artworkUrl100: string;
  advisories: any[];
  userRatingCountForCurrentVersion: number;
  screenshotUrls: string[];
  ipadScreenshotUrls: any[];
  averageUserRatingForCurrentVersion: number;
  sellerName: string;
  description: string;
  artistId: number;
  trackName: string;
  primaryGenreId: number;
  artistViewUrl: string;
  features: any[];
  releaseNotes: string;
  trackContentRating: string;
  genres: string[];
  price: number;
  currentVersionReleaseDate: string;
  userRatingCount: number;
  currency: string;
  wrapperType: string;
  isVppDeviceBasedLicensingEnabled: boolean;
  minimumOsVersion: string;
  contentAdvisoryRating: string;
  isGameCenterEnabled: boolean;
  releaseDate: string;
  kind: string;
  trackId: number;
  bundleId: string;
  languageCodesISO2A: string[];
  genreIds: string[];
  artworkUrl512: string;
  primaryGenreName: string;
  version: string;
  appletvScreenshotUrls: any[];
  fileSizeBytes: string;
  formattedPrice: string;
  artworkUrl60: string;
  sellerUrl: string;
  trackViewUrl: string;
  trackCensoredName: string;
  supportedDevices: string[];
  averageUserRating: number;
  artistName: string;
}

@Component({
  selector: 'app-app-help',
  templateUrl: './app-help.component.html',
  styleUrls: ['./app-help.component.scss']
})
export class AppHelpComponent implements OnInit {

  appResults: iOsAppMetaData;

  constructor(
    private appDataService: AppDataService,
    ) { }

  ngOnInit() {
    this.appDataService
      .getAppStoreData(this.appDataService.myPetsafe)
      .subscribe(
        data => {
          this.appResults = data.results[0];
        },
        error => {
          LoggerService.log(error, LOG_LEVEL.ERROR);
        },
      );
  }
}
